import { getProjects } from "../../services/newApi";
import { useEffect, useState } from "react";
import ProjectsView from "../../components/ProjectsView";
import Button from "../../components/ui/buttons/Button";
import TabContent from "./components/TabContent";
import H2Base from "../../components/ui/titles/H2Base";
import ProjectSearch from "./components/ProjectSearch";
import CTASubscription from "./components/CTASubscription";
import { useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import PageWrapper from "../../components/ui/wrappers/PageWrapper";
import Seo from "../../components/Seo";

const Projects = () => {
    const [activeTab, setActiveTab] = useState(3);
    const [tabContent, setTabContent] = useState([]);
    const [isTabButtonVisible, setIsTabButtonVisible] = useState(true);
    const [isSearching, setIsSearching] = useState(false);
    const [tabError, setTabError] = useState(null);
    const [searchInputValue, setSearchInputValue] = useState("");
    const {
        isPending: isLoading,
        data: currentProjects,
        error,
    } = useQuery({
        queryKey: ["project-notfinished"],
        queryFn: async () => getProjects("notfinished"),
    });
    const [refundedQuery, notstartedQuery, finishedQuery] = useQueries({
        queries: [
            {
                queryKey: ["project-refunded"],
                queryFn: () => getProjects("refunded"),
            },
            {
                queryKey: ["project-notstarted"],
                queryFn: () => getProjects("notstarted"),
            },
            {
                queryKey: ["project-finished"],
                queryFn: () => getProjects("finished"),
            }
        ],
    });
    const queryClient = useQueryClient();
    const searchQuery = queryClient.getQueryState(["project-search"]);
    const isTabLoading = refundedQuery.isLoading || notstartedQuery.isLoading || finishedQuery.isLoading || searchQuery.isLoading;

    const typeByTab = {
        1: "finished",
        2: "refunded",
        3: "notstarted",
    };

    const queryByType = {
        refunded: refundedQuery,
        notstarted: notstartedQuery,
        finished: finishedQuery
    };

    const handleTabBtnClick = async (nbTab) => {
        const type = typeByTab[nbTab];
        const query = queryByType[type];

        if (query.isSuccess) {
            setTabContent(query.data);
            setTabError(null);
        } else if (query.isError) {
            setTabError(query.error);
        }
        setSearchInputValue("");
        setActiveTab(nbTab);
    };

    useEffect(() => {
        if (notstartedQuery?.data && notstartedQuery?.data.length > 0) {
            setTabContent(notstartedQuery.data);
        } else if (finishedQuery?.data && finishedQuery?.data.length > 0) {
            setActiveTab(1);
            setTabContent(finishedQuery.data);
        }
    }, [notstartedQuery.data, finishedQuery.data]);

    return (
        <PageWrapper>
            <Seo
                title="Projets a financer"
                description="Decouvrez les projets a financer sur PretUp. Filtrez, analysez les opportunites et pretez aux entreprises en croissance."
            />
            <CTASubscription />
            <section>
                <ProjectsView
                    emptyTitle={"Des nouveaux projets sont en cours de preparation"}
                    isLoading={isLoading}
                    error={error?.message || ""}
                    projects={currentProjects?.slice(0, 8) || []}
                    title="Projets en cours de financement"
                />
            </section>
            <section>
                <div className="block justify-between mt-16">
                    <H2Base tailwindClass="lg:mb-0" text="Autres types de projets" />
                    <ProjectSearch
                        setActiveTab={setActiveTab}
                        setTabContent={setTabContent}
                        setTabError={setTabError}
                        setIsSearching={setIsSearching}
                        setIsTabButtonVisible={setIsTabButtonVisible}
                        searchInputValue={searchInputValue}
                        setSearchInputValue={setSearchInputValue}
                    />
                </div>

                <div className="my-16 flex justify-evenly">
                    <Button text="Projets a venir" btnType={activeTab === 3 ? "secondary" : "secondaryBorder"}
                        handleClick={() => handleTabBtnClick(3)} />
                    <Button text="Collectes terminees" btnType={activeTab === 1 ? "secondary" : "secondaryBorder"}
                        handleClick={() => handleTabBtnClick(1)} />
                    <Button text="Projets rembourses" btnType={activeTab === 2 ? "secondary" : "secondaryBorder"}
                        handleClick={() => handleTabBtnClick(2)} />
                </div>
                <TabContent content={tabContent || []} error={tabError?.message || ""} isLoading={isTabLoading}
                    isTabButtonVisible={isTabButtonVisible} />
            </section>
        </PageWrapper>
    );
};

export default Projects;
